var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowwithmiddledesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 649,
    height: 42,
    viewBox: "0 0 649 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 20L154 20",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7722 23.113C27.656 23.113 29.1831 21.5858 29.1831 19.702C29.1831 17.8182 27.656 16.291 25.7722 16.291C23.8883 16.291 22.3611 17.8182 22.3611 19.702C22.3611 21.5858 23.8883 23.113 25.7722 23.113Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.946 25.0084C161.877 25.0084 164.252 22.6329 164.252 19.7025C164.252 16.7721 161.877 14.3965 158.946 14.3965C156.016 14.3965 153.64 16.7721 153.64 19.7025C153.64 22.6329 156.016 25.0084 158.946 25.0084Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.702C0 19.702 13.644 23.1129 20.087 31.0719C20.087 31.0719 18.192 22.3549 18.192 19.702C18.192 17.049 20.087 8.33203 20.087 8.33203C13.644 16.291 0 19.702 0 19.702Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M622 20H493",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M623.411 23.113C625.295 23.113 626.822 21.5858 626.822 19.702C626.822 17.8182 625.295 16.291 623.411 16.291C621.527 16.291 620 17.8182 620 19.702C620 21.5858 621.527 23.113 623.411 23.113Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M488.675 25.0065C491.605 25.0065 493.981 22.6309 493.981 19.7005C493.981 16.7701 491.605 14.3945 488.675 14.3945C485.745 14.3945 483.369 16.7701 483.369 19.7005C483.369 22.6309 485.745 25.0065 488.675 25.0065Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M648.909 19.702C648.909 19.702 635.265 16.291 628.822 8.33203C628.822 8.33203 630.717 17.049 630.717 19.702C630.717 22.3549 628.822 31.0719 628.822 31.0719C635.265 23.1129 648.909 19.702 648.909 19.702Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M183.582 17.0483C190.025 19.7013 185.856 26.5233 181.308 26.9023C171.075 27.2813 169.938 18.9433 171.454 14.7744C174.865 6.43641 189.646 -0.00657652 205.943 1.13042C240.81 4.1624 270.751 32.2083 307.135 28.0393C312.062 27.2813 322.674 23.4913 319.263 13.2584C317.368 7.5734 311.683 6.05739 306.756 6.81538C304.103 7.19438 299.555 9.84737 300.692 16.2903C301.45 20.8383 310.167 23.8703 310.546 16.6694",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M174.486 10.6063C184.719 5.67931 201.395 6.81632 209.732 9.46931C229.819 15.9123 267.34 36.7572 289.701 35.6202C296.144 35.2412 307.135 33.7252 314.336 26.1452",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.486 10.6052C184.719 5.67827 208.216 13.6372 215.796 18.1852C233.988 28.4181 260.518 42.0621 282.879 40.9251C299.176 40.1671 307.135 33.3451 313.957 26.1442",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M463.661 17.0483C457.218 19.7013 461.387 26.5233 465.935 26.9023C476.168 27.2813 477.305 18.9433 475.789 14.7744C472.378 6.43641 457.597 -0.00657652 441.3 1.13042C406.432 4.1624 376.491 32.2083 340.107 28.0393C335.18 27.2813 324.568 23.4913 327.979 13.2584C329.874 7.5734 335.559 6.05739 340.486 6.81538C343.139 7.19438 347.687 9.84737 346.55 16.2903C345.792 20.8383 337.075 23.8703 336.696 16.6694",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M472.756 10.6063C462.523 5.67931 445.848 6.81632 437.51 9.46931C417.423 15.9123 379.902 36.7572 357.541 35.6202C351.098 35.2412 340.107 33.7252 332.906 26.1452",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M472.756 10.6052C462.523 5.67827 439.026 13.6372 431.446 18.1852C413.254 28.4181 386.724 42.0621 364.363 40.9251C348.066 40.1671 340.107 33.3451 333.285 26.1442",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowwithmiddledesign);
export default __webpack_public_path__ + "static/media/arrow with middle design.b272ecec98171e18a2fda0043265b5d7.svg";
export { ForwardRef as ReactComponent };